module.exports = __webpack_public_path__ + "static/media/logoDark.8b3bba11.png";